import React from 'react';
import { Close } from '@material-ui/icons';
import {TimeInputs} from "./TimeInputs";
import {EnableTime} from "../types.d"
import {useStyles} from "../styles"
interface IEnableTimes{
  timingArray:EnableTime[];
  day:string;
  removeTime:(day:string, index?:number,status?:boolean)=>void;
  updateTimingArray:(key:string,index:number,value:EnableTime)=>void,
  enabled:boolean
}
export  function EnableTimes({timingArray , removeTime , day , updateTimingArray,enabled}:IEnableTimes) {
  const classes = useStyles();
  function renderEnableTimes() {
    return timingArray?.map((time: EnableTime,index:number) => <div className={`${classes.TimeInputsWrapper} ${!enabled && classes.DisableEvents}` } >
    <TimeInputs time={time} index={index} day={day} updateTimingArray={updateTimingArray}/>
    <Close 
      data-component-name={`DELETE_BUTTON_${day}_${index}`}
      onClick={()=>removeTime(day,index,timingArray.length===1?false:undefined)}
    />
  </div>)
  }
  return (
    <div style={day==="Monday"?{borderRadius:"0 14px 0 0"}:day==="Sunday"?{borderRadius:"0 0 14px 0"}:undefined}>
      {renderEnableTimes()}
    </div>
  )
}
